import script from "./GroupDescribe.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupDescribe.vue?vue&type=script&setup=true&lang=js"

import "./GroupDescribe.vue?vue&type=style&index=0&id=55c6d4ac&scoped=true&lang=css"

import exportComponent from "/home/toor/projects/fc/formacloud-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c6d4ac"]])

export default __exports__